"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllHierarchicalTeams = exports.createGetAllHierarchicalTeams = exports.getAllTeams = exports.createGetAllTeams = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _formatTeams = _interopRequireDefault(require("reference-resolvers/formatters/formatTeams"));

var _formatHierarchicalTeams = _interopRequireDefault(require("reference-resolvers/formatters/formatHierarchicalTeams"));

var createGetAllTeams = function createGetAllTeams(_ref) {
  var httpClient = _ref.httpClient;
  return function () {
    return httpClient.get('app-users/v1/teams').then(_formatTeams.default);
  };
};

exports.createGetAllTeams = createGetAllTeams;
var getAllTeams = createGetAllTeams({
  httpClient: _apiClient.default
});
exports.getAllTeams = getAllTeams;

var createGetAllHierarchicalTeams = function createGetAllHierarchicalTeams(_ref2) {
  var httpClient = _ref2.httpClient;
  return function () {
    return httpClient.get('app-users/v1/teams?includeHierarchy=true').then(_formatHierarchicalTeams.default);
  };
};

exports.createGetAllHierarchicalTeams = createGetAllHierarchicalTeams;
var getAllHierarchicalTeams = createGetAllHierarchicalTeams({
  httpClient: _apiClient.default
});
exports.getAllHierarchicalTeams = getAllHierarchicalTeams;